export class FileUploader {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async uploadBytes(encryptedBytes, ownershipType, chunkId, apiToken) {
        const result = await this.apiService.uploadFileBytes(apiToken, ownershipType, chunkId, encryptedBytes);
        return result;
    }
}
